module.exports = __webpack_public_path__ + "img/tiger_half.fde2293c.svg";